const safeLocalStorage = {
    getItem:    (key)        => { try { return localStorage.getItem(key);    } catch { return null; } },
    setItem:    (key, value) => { try { localStorage.setItem(key, value);    } catch {} },
    removeItem: (key)        => { try { localStorage.removeItem(key);        } catch {} },
};

export {safeLocalStorage};
